
import request from '@/utils/request'
import { ENABLE_API_DBG } from '@/appConfig.js';

function list (params) {
  const {max, offset, ...rest} = params;
  const newParams = {take: max, skip: offset, ...rest};
  const qsParams = new URLSearchParams();
  for (let [key, value] of Object.entries(newParams)) {
    if (!Array.isArray(value)) {
      qsParams.append(key, value);
    }
    else {
      value.forEach(elem => qsParams.append(key, elem));
    }
  }
  ENABLE_API_DBG && console.log(`api.group.list: qsParams = ${qsParams.toString()}`);
  return request({
    url: `/group?${qsParams.toString()}`,
    method: 'get',
    data: params
  })
}
function get (itemId) {
  return request({
    url: `/group/${itemId}`,
    method: 'get'
  })
}
function getWithTags (itemId) {
  return request({
    url: `/group/${itemId}?relation=tags`,
    method: 'get'
  })
}
function getWithGroups (itemId) {
  return request({
    url: `/group/${itemId}?relation=groups`,
    method: 'get'
  })
}
function search (params) {
  return request({
    url: `/group/search`,
    method: 'post',
    data: params
  })
}
function add (params) {
  return request({
    url: `/group`,
    method: 'post',
    data: params
  })
}
function update (params) {
  return request({
    url: `/group/${params.id}`,
    method: 'patch',
    data: params
  })
}
function remove (itemId) {
  return request({
    url: `/group/${itemId}`,
    method: 'delete'
  })
}
export default {
    list,
    search,
    add,
    update,
    remove,
    get,
    getWithTags,
    getWithGroups
}
